import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const AppWrapper = styled.main`
  position: relative;
  display: flex;
  height: 100%;
  width: 1680px;
  min-height: 100vh;
  margin: 0 auto;
  background-color: ${COLORS.background};
`;

export default AppWrapper;
